module.exports = __webpack_public_path__ + "img/slider_mobil.03f4127b.gif";